import classNames from 'classnames';
import { FC } from 'react';
import StarRateEmpty from '$/components/cms/icons/StarRateEmpty';
import StarRateFull from '$/components/cms/icons/StarRateFull';

interface Props {
  rating?: number;
}

export const CustomerReviewBlockStars: FC<Props> = ({ rating }) => {
  return (
    <div className="flex items-center" aria-hidden="true">
      {Array.from({ length: 5 }).map((_, index) => {
        const isFilled = rating !== undefined && index < Math.round(rating);
        const RateIcon = isFilled ? StarRateFull : StarRateEmpty;
        return (
          <RateIcon
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={classNames('size-5 text-campaign/yellow-complimentary')}
          />
        );
      })}
    </div>
  );
};
